import { Injectable } from '@angular/core';
import { ResumenFirmas } from 'src/app/pages/panelControl/models/resumen-firmas';
import { ResumenEstados } from 'src/app/pages/panelControl/models/resumen-inicial';

@Injectable({
  providedIn: 'root'
})
export class ModificarArraysService {

  constructor() { }

  // swapElements(array: ResumenFirmas[], index1: number, index2: number) {
  swapElements(array: any[], index1: number, index2: number) {
    if (index1 < 0 || index1 >= array.length || index2 < 0 || index2 >= array.length) {
      return;
    }
    const temp = array[index1];
    array[index1] = array[index2];
    array[index2] = temp;
  }

    swapObjectProperties(obj: ResumenEstados, key1: string, key2: string): void {
    if (!obj || !key1 || !key2 || !obj.hasOwnProperty(key1) || !obj.hasOwnProperty(key2)) {
      return; // Handle invalid input
    }

    const temp = { ...obj[key1] }; // Create a copy to avoid modifying the original during the swap
    obj[key1] = { ...obj[key2] };
    obj[key2] = temp;
  }

  ordenarResumenEstados(resumenEstados: ResumenEstados[]){
    if (!Array.isArray(resumenEstados)) return resumenEstados;

    const normalize = (v: string | null | undefined) =>
      (v ?? '').toString().trim().toLowerCase().replace(/\s+/g, '');

    // Desired order (user-defined)
    const ORDER = [
      'todos',
      'borradors',
      'firmados',
      'parcialmentefirmados',
      'nofirmados',
      'rechazados',
      'caducados',
      'cancelados',
      'errores',
    ] as const;

    // Map common variants to the canonical key above
    const ALIAS: Record<string, (typeof ORDER)[number]> = {
      borradores: 'borradors',
      borrador: 'borradors',
      firmado: 'firmados',
      parcialmentefirmado: 'parcialmentefirmados',
      nofirmado: 'nofirmados',
      rechazado: 'rechazados',
      caducado: 'caducados',
      cancelado: 'cancelados',
      error: 'errores',
    };

    const rank = new Map<(typeof ORDER)[number], number>(ORDER.map((k, i) => [k, i]));
    const getRank = (tipoEstado: string | null | undefined) => {
      const key = normalize(tipoEstado);
      const canonical = (ALIAS[key] ?? (key as (typeof ORDER)[number]));
      return rank.get(canonical) ?? Number.POSITIVE_INFINITY;
    };

    // Stable sort: preserve original order for ties/unknowns
    return resumenEstados
      .map((item, idx) => ({ item, idx }))
      .sort((a, b) => getRank(a.item?.tipoEstado) - getRank(b.item?.tipoEstado) || a.idx - b.idx)
      .map(x => x.item);
  }
}
